import * as graphql from '@treams/treams-network';

export interface INoteMetaEditorValues {
	title: string;
	date: Date;
	subjectID?: string;
}

export function useUpdateNote(note: graphql.Note) {
	const [update, { error }] = graphql.useUpdateNoteMutation();

	const updateNote = async (values: INoteMetaEditorValues) => {
		const date = [
			values.date.getFullYear().toFixed().padStart(4, '0'),
			(values.date.getMonth() + 1).toFixed().padStart(2, '0'),
			values.date.getDate().toFixed().padStart(2, '0'),
		].join('-');

		if (
			note.date === date &&
			note.title === values.title &&
			note.subject?.id === values.subjectID
		) {
			return;
		}

		await update({
			variables: {
				input: {
					noteID: note.id,
					title: values.title,
					date,
					subjectID: values.subjectID,
				},
			},
		});
	};

	return { updateNote, error: error?.graphQLErrors[0] };
}
